import React from "react";
import { Link } from "react-router-dom";
import { Dice5, Gamepad2, Rocket, Sprout } from "lucide-react";
import { useWalletUser, ConnectPrompt } from "@/App";

export default function ArcadePage() {
  const { isConnected, user } = useWalletUser();
  if (!isConnected) return <ConnectPrompt />;

  const games = [
    { to: "/arcade/spin", title: "Lucky Spin", desc: "Spin for up to 50x FLAME. One roll, hot vibes.", color: "from-amber-500/30 to-rose-500/10", icon: Dice5, tid: "arcade-game-spin" },
    { to: "/arcade/blackjack", title: "Cronos Blackjack", desc: "Beat the dealer. Natural 21 = 2.5x payout.", color: "from-emerald-500/30 to-cyan-500/10", icon: Gamepad2, tid: "arcade-game-blackjack" },
    { to: "/arcade/crash", title: "Rocket Crash", desc: "Launch, climb, cash out before boom.", color: "from-cyan-500/30 to-indigo-500/10", icon: Rocket, tid: "arcade-game-crash" },
    { to: "/farm", title: "FLAME Farm", desc: "Cozy crop grinding for passive FLAME.", color: "from-orange-500/30 to-amber-500/10", icon: Sprout, tid: "arcade-game-farm" },
    { to: "/farm/valley", title: "Flame Valley", desc: "Isometric farm: buy seeds with CRO, harvest FLAME before it withers.", color: "from-emerald-500/30 to-amber-500/10", icon: Sprout, tid: "arcade-game-valley" },
  ];

  return (
    <div className="pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="font-display text-4xl font-black">Arcade</h1>
        <p className="text-slate-400 mt-1">Credits: <span className="text-cyan-400 font-mono">{user?.credits ?? 0}</span> • FLAME: <span className="text-orange-400 font-mono">{user?.flame ?? 0}</span></p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
          {games.map((g) => (
            <Link key={g.to} to={g.to} data-testid={g.tid}
              className={`relative overflow-hidden card-tile hover:border-orange-500/40 transition group`}>
              <div className={`absolute inset-0 bg-gradient-to-br ${g.color} opacity-70 pointer-events-none`} />
              <div className="relative flex items-center gap-5 p-4">
                <div className="rounded-2xl bg-black/40 p-4 border border-white/10"><g.icon size={42} className="text-white" /></div>
                <div>
                  <div className="font-display text-2xl font-black">{g.title}</div>
                  <div className="text-sm text-slate-200/80 mt-1">{g.desc}</div>
                </div>
                <div className="ml-auto font-pixel text-[10px] text-slate-300 group-hover:text-white">PLAY ▸</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
